import { createFileRoute } from "@tanstack/react-router";
import { fetchCustomerByIdQueryOptions } from "@/api/customers";
import { fetchCustomerEnrollmentsQueryOptions } from "@/api/enrollments";
import { fetchCustomerMedicalRecordsQueryOptions } from "@/api/medicalRecords";
import { useApiParameters } from "@/hooks/useApiParameters";
import { CustomerOverview } from "@/routes/_auth/app/_app/org/$orgId/customers/-components/CustomerOverview";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/customers/$customerId/",
)({
	loader: async ({ context, params }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);
		const { orgId, customerId } = params;

		// Preload customer data
		context.queryClient.ensureQueryData(
			fetchCustomerByIdQueryOptions(userId, token, orgId, customerId),
		);

		// Preload medical records data
		context.queryClient.ensureQueryData(
			fetchCustomerMedicalRecordsQueryOptions(userId, token, orgId, customerId),
		);

		// Preload enrollments data (first page for overview)
		context.queryClient.ensureQueryData(
			fetchCustomerEnrollmentsQueryOptions(userId, token, orgId, customerId, {
				page: 1,
				limit: 10,
			}),
		);

		return { userId, token, orgId, customerId };
	},
	component: CustomerOverviewPage,
});

function CustomerOverviewPage() {
	const { orgId, customerId } = Route.useParams();
	const { userId, token } = Route.useLoaderData();

	return (
		<div className="h-full flex flex-col space-y-6">
			<div className="h-full overflow-auto">
				<CustomerOverview
					organizationId={orgId}
					customerId={customerId}
					userId={userId}
					token={token}
				/>
			</div>
		</div>
	);
}
